import { _ } from '../utils'

class Countdown {
    constructor(el) {
        this.complete = Date.parse(el.dataset.goal)
        this.counter = _('countdown-counter', 'element').nodeFrom(el)
        this.dateTimeEl = _('date-time','element').node()
        this.timeinterval = null

        this.updateClock()
        this.timeInterval = setInterval(this.updateClock, 1000)
    }

    getTimeRemaining = () => {
        this.now = new Date()
        this.diff = this.complete - this.now

        this.days = Math.floor(this.diff / (1000 * 60 * 60 * 24))
        this.hours = Math.floor(this.diff / (1000 * 60 * 60))
        this.mins = Math.floor(this.diff / (1000 * 60))
        this.secs = Math.floor(this.diff / 1000)
  
        this.d = this.days
        this.h = this.hours - this.days * 24
        this.m = this.mins - this.hours * 60
        this.s = this.secs - this.mins * 60

    }

    updateClock = () => {
        this.getTimeRemaining()
        this.counter.innerHTML = (('0' + this.h).slice(-2) + ':' + ('0' + this.m).slice(-2) + ':' + ('0' + this.s).slice(-2))

        if (this.diff <= 0) {
            clearInterval(this.timeinterval)
            this.counter.innerHTML = '00:00:00'
            document.querySelector('.offer__btn-reveal--hidden').classList.remove('u-hidden')
            document.querySelector('.offer__countdown').classList.add('u-hidden')
        }
    }
}
export default Countdown

